import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { FieldError } from 'react-hook-form';
import { useExpenseOptions } from 'shared/queries';

interface ExpenseTypeDropdownProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  disabled?: boolean;
  error?: FieldError;
  defaultValue?: string;
}

export function ExpenseTypeDropdown({ name, disabled, error, defaultValue = '' }: ExpenseTypeDropdownProps) {
  const { expenseOptions, isFetching, isLoading } = useExpenseOptions();
  const {
    field: { value, ref, onChange },
  } = useController({
    name,
    rules: { required: { message: 'Expense Type is required', value: true } },
    defaultValue,
  });

  const loading = isLoading || isFetching;

  return (
    <Autocomplete
      id={name}
      value={value}
      disabled={disabled}
      onChange={(_, value) => {
        onChange(value);
      }}
      onInputChange={(_, value) => {
        onChange(value);
      }}
      freeSolo
      selectOnFocus
      clearOnBlur
      options={expenseOptions || []}
      loading={loading}
      ref={ref}
      fullWidth
      renderInput={params => (
        <TextField
          {...params}
          label='Expense type'
          variant='outlined'
          error={Boolean(error)}
          helperText={error?.message}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color='inherit' size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
